<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-2 text-left text-success">
          <base-input label="Feeder Pillar:" style="color: #15acc9">
            <el-select
              class="select-default"
              placeholder="Choose..."
              size="large"
              @change="getFpInfo()"
              v-model="fpid"
            >
              <el-option
                v-for="option in fpList"
                class="select-primary"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </base-input>
        </div>
        <div class="col-lg text-right text-bottom">
          <p>Last data update: {{ lastupdateddata }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4">
          <div class="row">
            <div class="col-lg text-center">
              <!-- on/off button -->
              <card v-if="fpcontrol">
                <p class="text-center">Feeder Pillar - {{ fpinfo.fpname }}</p>
                <br />
                <div class="row">
                  <div class="col-lg">
                    <base-button
                      class="btn-success"
                      v-on:click="FpControl('ONOFF', 'ON')"
                      >Turn On
                    </base-button>
                  </div>
                  <div class="col-lg">
                    <base-button
                      class="btn"
                      v-on:click="FpControl('ONOFF', 'OFF')"
                      >Turn Off
                    </base-button>
                  </div>
                </div>
                <br />
                <!-- <p class="text-center">Last Action :  {{ laston }}</p> -->
              </card>
              <card style="background-color: #848484" v-else>
                <p class="text-center fonta">
                  Feeder Pillar - {{ fpinfo.fpname }}
                </p>
                <br />
                <div class="row">
                  <div class="col-lg">
                    <base-button
                      class="btn-success"
                      disabled
                      style="background-color: #a4a4a4; color: #ffffff"
                      >Turn On
                    </base-button>
                  </div>
                  <div class="col-lg">
                    <base-button
                      class="btn"
                      disabled
                      style="background-color: #a4a4a4; color: #ffffff"
                      >Turn Off
                    </base-button>
                  </div>
                </div>
                <br />
                <p
                  class="text-center"
                  style="color: #c10d19; font-style: bold; font-size: 16px"
                >
                  <img src="@/assets/img/warning.png" width="20" /> Please turn
                  the switch on the feeder pillar to <br />'Smart' to control
                  using the dashboard
                </p>
              </card>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 text-right">
              <!-- energy cost -->
              <card>
                <p class="fonta">Energy Cost to Date (MYR)</p>
                <p style="font-size: 25px">{{ energycosttodate }}</p>
                <p class="fonta">Since {{ energydate }}</p>
              </card>
            </div>
            <div class="col-lg-6 text-right">
              <!-- total energy -->
              <card>
                <p class="fonta">Total Energy (kWh)</p>
                <p style="font-size: 25px">{{ fpLastData.ttlenergy }}</p>
                <p class="fonta">Since {{ ttlenergydate }}</p>
              </card>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 text-right">
              <!-- mlc status -->
              <card>
                <p class="fonta">MLC Status</p>
                <p style="font-size: 25px">{{ fpLastData.mlcstatus }}</p>
              </card>
            </div>
            <div class="col-lg-6 text-right">
              <!-- control mode -->
              <card>
                <p class="fonta">Control Mode</p>
                <p style="font-size: 25px">{{ fpLastData.controlmode }}</p>
              </card>
            </div>
          </div>
        </div>
        <div class="col-lg-8 d-flex">
          <!-- map -->
          <card class="card-plain">
            <l-map
              v-model="center"
              ref="map"
              id="toto"
              :zoom="zoom"
              :center="center"
              :bounds="devBounds"
              class="sidebar-map"
              :options="{ scrollWheelZoom: false }"
            >
              <!-- :bounds="devBounds" -->
              <l-tile-layer
                :url="url"
                :attribution="attribution"
              ></l-tile-layer>
              <l-marker
                v-for="marker in markers"
                :icon="markerIcon(marker.flag)"
                :key="marker.addMarker"
                :lat-lng="marker.location"
                ref="markersRef"
              >
                <l-tooltip :content="marker.deviceName" />
              </l-marker>
              <l-control position="topleft">
                <div style="" class="hoi" @click="drawer = true">
                  <!-- <base-button > -->
                  <i class="fa fa-caret-right" aria-hidden="true"></i>
                  <!-- </base-button> -->
                </div>
              </l-control>
              <l-control position="topleft">
                <div id="legend">
                  <!-- <b style="font-size: 12px">Legend</b> -->
                  <div class="legend_attr">
                    <img
                      src="@/assets/img/mlc - smart ready.png"
                      style="width: 16px"
                    />
                    Smart Ready
                  </div>
                  <div class="legend_attr">
                    <img
                      src="@/assets/img/Electrical fault icon 2.png"
                      style="width: 16px"
                    />
                    HPSV / SON
                  </div>
                  <div class="legend_attr">
                    <img
                      src="@/assets/img/feeder_pillar.png"
                      style="width: 20px; height: 23px"
                    />
                    Feeder Pillar
                  </div>
                </div>
              </l-control>
              <el-drawer
                class="drawer"
                title="I am the title"
                :visible.sync="drawer"
                :with-header="false"
                size="353px"
              >
                <div
                  class="row"
                  style="
                    background-color: #27293d;
                    padding: 15px;
                    font-family: 'Poppins', sans-serif;
                    width: 350px;
                    overflow-x: hidden;
                  "
                >
                  <div class="col-lg-12">
                    <div class="row">
                      <div class="col-lg">
                        <p style="font-size: 18px">Door and Override Status</p>
                      </div>
                    </div>
                    <br />
                    <div
                      class="row"
                      v-for="item in alertinfolist"
                      :key="item.id"
                    >
                      <div class="col-lg-4">
                        <p>{{ item.time }}</p>
                        <p>{{ item.date }}</p>
                      </div>
                      <div class="col-lg-8">
                        <p>{{ item.desc }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </el-drawer>
            </l-map>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-lg text-center d-flex">
          <!-- last fd door opened-->
          <card style="padding: 30px 0">
            <div>
              <p class="fonta">Last FP Door Opened</p>
              <p style="font-size: 25px">{{ fpAlertInfo.lastdooropened }}</p>
              <!-- <p class="fonta">ago</p> -->
            </div>
          </card>
        </div>
        <div class="col-lg text-center d-flex">
          <!-- fp door 1 | fp door 2 -->
          <card style="padding: 10px 0">
            <br />
            <div class="row">
              <!-- style="border-right: 1px solid #a8a8a6" -->
              <div class="col-lg" >
                <p class="fonta">FP Door 1</p>
                <p style="font-size: 22px">{{ fpLastData.Door1Status }}</p>
                <!-- <p
                  class="text-center"
                  style="color: #c10d19; font-style: bold; font-size: 16px"
                >
                  <img src="@/assets/img/warning.png" width="20" /> Door 1
                  opened at <br />{{ timeopened }} {{ dateopened }}
                </p> -->
              </div>
              <!-- <div class="col-lg">
                <p class="fonta">FP Door 2</p>
                <p style="font-size: 22px">{{ fpLastData.Door2Status }}</p>
                 <p
                  class="text-center"
                  style="color: #c10d19; font-style: bold; font-size: 16px"
                >
                  <img src="@/assets/img/warning.png" width="20" /> Door 2
                  opened at <br />{{ timeopened }} {{ dateopened }}
                </p>
              </div> -->
            </div>
          </card>
        </div>
        <div class="col-lg text-center d-flex">
          <!-- rssi  -->
          <card style="padding: 25px 0">
            <p class="">RSSI</p>
            <div class="row">
              <div class="col-lg" style="border-right: 1px solid #ffffff">
                <p style="font-size: 22px">{{ fpLastData.node }}</p>
                <p class="">Node</p>
              </div>
              <div class="col-lg">
                <p style="font-size: 22px">{{ fpLastData.gateway }}</p>
                <p class="">Gateway</p>
              </div>
            </div>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-lg text-center">
          <!-- chart daily voltage -->
          <card>
            <div class="row">
              <div class="col-lg">
                <p class="">Daily Voltage 1</p>
              </div>
              <!-- <div class="col-lg-3">
                <base-input style="color: #15acc9">
                  <el-select
                    class="select-default"
                    placeholder="Choose..."
                    size="large"
                    v-model="range"
                  >
                    <el-option
                      v-for="option in ranges"
                      class="select-primary"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    ></el-option>
                  </el-select>
                </base-input>
              </div> -->
            </div>
            <div class="chart-area">
              <line-chart
                :chart-data="lineChart1.chartData"
                :gradient-colors="lineChart1.gradientColors"
                :gradient-stops="lineChart1.gradientStops"
                :extra-options="lineChart1.extraOptions"
                :height="200"
              >
              </line-chart>
            </div>
          </card>
        </div>
        <div class="col-lg text-center">
          <!-- chart daily current -->
          <card>
            <div class="row">
              <div class="col-lg">
                <p class="">Daily Voltage 2</p>
              </div>
              <!-- <div class="col-lg-3">
                <base-input style="color: #15acc9">
                  <el-select
                    class="select-default"
                    placeholder="Choose..."
                    size="large"
                    v-model="range"
                  >
                    <el-option
                      v-for="option in ranges"
                      class="select-primary"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    ></el-option>
                  </el-select>
                </base-input>
              </div> -->
            </div>

            <div class="chart-area">
              <line-chart
                :chart-data="lineChart2.chartData"
                :gradient-colors="lineChart2.gradientColors"
                :gradient-stops="lineChart2.gradientStops"
                :extra-options="lineChart2.extraOptions"
                :height="200"
              >
              </line-chart>
            </div>
          </card>
        </div>
        <div class="col-lg text-center">
          <!-- chart daily energy -->
          <card>
            <div class="row">
              <div class="col-lg">
                <p class="">Daily Voltage 3</p>
              </div>
              <!-- <div class="col-lg-3">
                <base-input style="color: #15acc9">
                  <el-select
                    class="select-default"
                    placeholder="Choose..."
                    size="large"
                    v-model="range"
                  >
                    <el-option
                      v-for="option in ranges"
                      class="select-primary"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    ></el-option>
                  </el-select>
                </base-input>
              </div> -->
            </div>

            <div class="chart-area">
              <line-chart
                :chart-data="lineChart3.chartData"
                :gradient-colors="lineChart3.gradientColors"
                :gradient-stops="lineChart3.gradientStops"
                :extra-options="lineChart3.extraOptions"
                :height="200"
              >
              </line-chart>
            </div>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-lg text-center">
          <!-- chart daily voltage -->
          <card>
            <div class="row">
              <div class="col-lg">
                <p class="">Daily Current 1</p>
              </div>
              <!-- <div class="col-lg-3">
                <base-input style="color: #15acc9">
                  <el-select
                    class="select-default"
                    placeholder="Choose..."
                    size="large"
                    v-model="range"
                  >
                    <el-option
                      v-for="option in ranges"
                      class="select-primary"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    ></el-option>
                  </el-select>
                </base-input>
              </div> -->
            </div>
            <div class="chart-area">
              <line-chart
                :chart-data="lineChart4.chartData"
                :gradient-colors="lineChart4.gradientColors"
                :gradient-stops="lineChart4.gradientStops"
                :extra-options="lineChart4.extraOptions"
                :height="200"
              >
              </line-chart>
            </div>
          </card>
        </div>
        <div class="col-lg text-center">
          <!-- chart daily current -->
          <card>
            <div class="row">
              <div class="col-lg">
                <p class="">Daily Current 2</p>
              </div>
              <!-- <div class="col-lg-3">
                <base-input style="color: #15acc9">
                  <el-select
                    class="select-default"
                    placeholder="Choose..."
                    size="large"
                    v-model="range"
                  >
                    <el-option
                      v-for="option in ranges"
                      class="select-primary"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    ></el-option>
                  </el-select>
                </base-input>
              </div> -->
            </div>

            <div class="chart-area">
              <line-chart
                :chart-data="lineChart5.chartData"
                :gradient-colors="lineChart5.gradientColors"
                :gradient-stops="lineChart5.gradientStops"
                :extra-options="lineChart5.extraOptions"
                :height="200"
              >
              </line-chart>
            </div>
          </card>
        </div>
        <div class="col-lg text-center">
          <!-- chart daily energy -->
          <card>
            <div class="row">
              <div class="col-lg">
                <p class="">Daily Current 3</p>
              </div>
              <!-- <div class="col-lg-3">
                <base-input style="color: #15acc9">
                  <el-select
                    class="select-default"
                    placeholder="Choose..."
                    size="large"
                    v-model="range"
                  >
                    <el-option
                      v-for="option in ranges"
                      class="select-primary"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    ></el-option>
                  </el-select>
                </base-input>
              </div> -->
            </div>

            <div class="chart-area">
              <line-chart
                :chart-data="lineChart6.chartData"
                :gradient-colors="lineChart6.gradientColors"
                :gradient-stops="lineChart6.gradientStops"
                :extra-options="lineChart6.extraOptions"
                :height="200"
              >
              </line-chart>
            </div>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-lg text-center">
          <!-- chart daily voltage -->
          <card>
            <div class="row">
              <div class="col-lg">
                <p class="">Daily Energy 1 (kWh)</p>
              </div>
              <!-- <div class="col-lg-3">
                <base-input style="color: #15acc9">
                  <el-select
                    class="select-default"
                    placeholder="Choose..."
                    size="large"
                    v-model="range"
                  >
                    <el-option
                      v-for="option in ranges"
                      class="select-primary"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    ></el-option>
                  </el-select>
                </base-input>
              </div> -->
            </div>
            <div class="chart-area">
              <line-chart
                :chart-data="lineChart7.chartData"
                :gradient-colors="lineChart7.gradientColors"
                :gradient-stops="lineChart7.gradientStops"
                :extra-options="lineChart7.extraOptions"
                :height="200"
              >
              </line-chart>
            </div>
          </card>
        </div>
        <div class="col-lg text-center">
          <!-- chart daily current -->
          <card>
            <div class="row">
              <div class="col-lg">
                <p class="">Daily Energy 2 (kWh)</p>
              </div>
              <!-- <div class="col-lg-3">
                <base-input style="color: #15acc9">
                  <el-select
                    class="select-default"
                    placeholder="Choose..."
                    size="large"
                    v-model="range"
                  >
                    <el-option
                      v-for="option in ranges"
                      class="select-primary"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    ></el-option>
                  </el-select>
                </base-input>
              </div> -->
            </div>

            <div class="chart-area">
              <line-chart
                :chart-data="lineChart8.chartData"
                :gradient-colors="lineChart8.gradientColors"
                :gradient-stops="lineChart8.gradientStops"
                :extra-options="lineChart8.extraOptions"
                :height="200"
              >
              </line-chart>
            </div>
          </card>
        </div>
        <div class="col-lg text-center">
          <!-- chart daily energy -->
          <card>
            <div class="row">
              <div class="col-lg">
                <p class="">Daily Energy 3 (kWh)</p>
              </div>
              <!-- <div class="col-lg-3">
                <base-input style="color: #15acc9">
                  <el-select
                    class="select-default"
                    placeholder="Choose..."
                    size="large"
                    v-model="range"
                  >
                    <el-option
                      v-for="option in ranges"
                      class="select-primary"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    ></el-option>
                  </el-select>
                </base-input>
              </div> -->
            </div>

            <div class="chart-area">
              <line-chart
                :chart-data="lineChart9.chartData"
                :gradient-colors="lineChart9.gradientColors"
                :gradient-stops="lineChart9.gradientStops"
                :extra-options="lineChart9.extraOptions"
                :height="200"
              >
              </line-chart>
            </div>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-lg text-center d-flex">
          <card style="padding: 10px 0">
            <br />
            <div class="row">
              <div class="col-lg">
                <p class="fonta">Voltage</p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg" style="border-right: 1px solid #a8a8a6">
                <p style="font-size: 22px">{{ fpLastData.voltagel1 }} v</p>
                <p
                  class="text-center"
                  style="font-style: bold; font-size: 16px"
                >
                  L1
                </p>
              </div>
              <div class="col-lg" style="border-right: 1px solid #a8a8a6">
                <p style="font-size: 22px">{{ fpLastData.voltagel2 }} v</p>
                <p
                  class="text-center"
                  style="font-style: bold; font-size: 16px"
                >
                  L2
                </p>
              </div>
              <div class="col-lg">
                <p style="font-size: 22px">{{ fpLastData.voltagel3 }} v</p>
                <p
                  class="text-center"
                  style="font-style: bold; font-size: 16px"
                >
                  L3
                </p>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg text-center d-flex">
          <card style="padding: 10px 0">
            <br />
            <div class="row">
              <div class="col-lg">
                <p class="fonta">Current</p>
              </div>
            </div>

            <div class="row">
              <div class="col-lg" style="border-right: 1px solid #a8a8a6">
                <p style="font-size: 22px">{{ fpLastData.currentl1 }} A</p>
                <p
                  class="text-center"
                  style="font-style: bold; font-size: 16px"
                >
                  L1
                </p>
              </div>
              <div class="col-lg" style="border-right: 1px solid #a8a8a6">
                <p style="font-size: 22px">{{ fpLastData.currentl2 }} A</p>
                <p
                  class="text-center"
                  style="font-style: bold; font-size: 16px"
                >
                  L2
                </p>
              </div>
              <div class="col-lg">
                <p style="font-size: 22px">{{ fpLastData.currentl3 }} A</p>
                <p
                  class="text-center"
                  style="font-style: bold; font-size: 16px"
                >
                  L3
                </p>
              </div>
            </div>

            <!-- <div class="col-lg" style="">
                <p style="font-size: 45px; display: inline">
                  {{ fpLastData.totalcurrent }}
                </p>
                <p style="font-size: 22px; display: inline">A</p>
                <p
                  class="text-center"
                  style="font-style: bold; font-size: 16px"
                >
                  Total
                </p>
              </div> -->
          </card>
        </div>
        <div class="col-lg text-center d-flex">
          <card style="padding: 10px 0">
            <br />
            <div class="row">
              <div class="col-lg">
                <p class="fonta">Energy</p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg" style="border-right: 1px solid #a8a8a6">
                <p class="fonta text-left" style="display: inline">L1 :</p>
                <p style="font-size: 22px; display: inline">
                  {{ fpLastData.energyl1 }} kWh
                </p>
                <br />
                <p class="fonta text-left" style="display: inline">L2 :</p>
                <p style="font-size: 22px; display: inline">
                  {{ fpLastData.energyl2 }} kWh
                </p>
                <br />
                <p class="fonta text-left" style="display: inline">L3 :</p>
                <p style="font-size: 22px; display: inline">
                  {{ fpLastData.energyl3 }} kWh
                </p>
              </div>
              <div class="col-lg" style="">
                <p style="font-size: 45px; display: inline">
                  {{ fpLastData.ttlenergy }}
                </p>
                <p style="font-size: 22px; display: inline">kWh</p>
                <p
                  class="text-center"
                  style="font-style: bold; font-size: 16px"
                >
                  Total
                </p>
              </div>
            </div>
          </card>
        </div>
      </div>
      <!-- modal -->
      <modal :show.sync="modals.alert" type="medium">
        <template slot="header">
          <h3
            class="modal-title"
            id="exampleModalLabel"
            style="color: #ffffff"
          ></h3>
        </template>
        <div>
          <div class="row">
            <div class="col-lg text-center">
              <img src="@/assets/img/warning.png" width="130px" />
              <br />
              <h1 style="color: #fe0000">WARNING!</h1>
            </div>
          </div>
          <div class="row">
            <div class="col-lg text-center">
              <h3 style="color: #000000">FP 01 manual override activated</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-lg text-center">
              <h4 style="color: grey">
                Please turn the switch on the <br />
                feeder pillar to 'Smart' to control using <br />
                the dashboard
              </h4>
            </div>
          </div>
          <div class="row">
            <div class="col-lg text-center">
              <base-button
                @click="
                  modals.alert = false;
                  modals.laststate = true;
                "
                class="btn-success"
              >
                OK
              </base-button>
            </div>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import { Select, Option, Drawer } from "element-ui";
import moment from "moment";
import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LControlSidebar,
  LLayerGroup,
  LTooltip,
  LControl,
} from "vue2-leaflet";
import LineChart from "src/components/Charts/LineChart";
import config from "@/config";
import * as chartConfigs from "@/components/Charts/config";
import { Modal } from "src/components";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Drawer.name]: Drawer,
    LMap,
    LTileLayer,
    LMarker,
    LLayerGroup,
    LPopup,
    LControl,
    LTooltip,
    LineChart,
    Modal,
  },
  data() {
    return {
      socket: "",
      devBounds: [[2.921182, 101.636671]],
      modals: {
        laststate: false,
        alert: false,
      },
      fpAlertInfo: {
        lastdooropened: "",
      },
      fpList: [],
      fpLastData: {
        voltagel1: 0,
        voltagel2: 0,
        voltagel3: 0,
        currentl1: 0,
        currentl2: 0,
        currentl3: 0,
        totalcurrent: 0,
        energyl1: 0,
        energyl2: 0,
        energyl3: 0,
        ttlenergy: 0,
        mlcstatus: "Unknown",
        controlmode: "Unknown",
        Door1Status: "Unknown",
        Door2Status: "Unknown",
        node: 0,
        gateway: 0,
      },
      ranges: [
        {
          value: "All",
          label: "All",
        },
      ],
      fpinfo: {
        fpname: "FP 01",
        conntype: "",
        fpid: "",
        fptoken: "",
        tariff: 0.0,
      },

      range: "",
      fpcontrol: false,
      fpid: "",
      lastupdateddata: "",
      laston: "10",
      energycosttodate: 0.0,
      energydate: "01/12/2021",
      totalenergy: "15.93",
      ttlenergydate: "01/12/2021",
      lastdooropened: "5",
      door1: "Closed",
      door2: "Closed",
      timeopened: "2:30pm",
      dateopened: "2/12/21",

      zoom: 18,
      center: L.latLng(3.15464, 101.718635),
      url: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors ',
      markers: [
        {
          flag: "hpsvson",
          location: L.latLng(2.921182, 101.636671),
        },
        {
          flag: "smart",
          location: L.latLng(2.921392, 101.636981),
        },
        {
          flag: "fp",
          location: L.latLng(2.921792, 101.636781),
        },
      ],
      markerIcon(flag) {
        if (flag == "smart") {
          return L.icon({
            iconSize: [30, 30], // size of the icon
            iconUrl: require("@/assets/img/mlc - smart ready.png"),
            // iconUrl: require("@/asse   ts/img/icon_on.png"),
            // iconSize: [30, 35], // size of the icon
            // shadowUrl: require("@/assets/img/marker-shadow.png"),
            iconAnchor: [30, 30], // point of the icon which will correspond to marker's location
            // shadowAnchor: [30, 30], // the same for the shadow
            // shadowSize: [30, 30],
            popupAnchor: [-3, -76],
          });
        } else if (flag == "fp") {
          return L.icon({
            iconSize: [30, 30], // size of the icon
            iconUrl: require("@/assets/img/feeder_pillar.png"),
            // iconUrl: require("@/assets/img/icon_on.png"),
            // iconSize: [30, 35], // size of the icon
            // shadowUrl: require("@/assets/img/marker-shadow.png"),
            iconAnchor: [30, 30], // point of the icon which will correspond to marker's location
            // shadowAnchor: [30, 30], // the same for the shadow
            // shadowSize: [30, 30],
            popupAnchor: [-3, -76],
          });
        } else {
          return L.icon({
            iconSize: [30, 30], // size of the icon
            iconUrl: require("@/assets/img/mlc - HPSVson.png"),
            // iconUrl: require("@/assets/img/icon_on.png"),
            // iconSize: [30, 35], // size of the icon
            // shadowUrl: require("@/assets/img/marker-shadow.png"),
            iconAnchor: [30, 30], // point of the icon which will correspond to marker's location
            // shadowAnchor: [30, 30], // the same for the shadow
            // shadowSize: [30, 30],
            popupAnchor: [-3, -76],
          });
        }
      },
      drawer: false,
      alertinfolist: [
        {
          id: 1,
          time: "10:45am",
          date: "2/12/21",
          desc: "Door 1 has been opened",
        },
        {
          id: 2,
          time: "10:45am",
          date: "2/12/21",
          desc: "Door 1 has been opened",
        },
        {
          id: 3,
          time: "10:45am",
          date: "2/12/21",
          desc: "Door 1 has been opened",
        },
        {
          id: 4,
          time: "10:45am",
          date: "2/12/21",
          desc: "Door 1 has been opened",
        },
        {
          id: 5,
          time: "10:45am",
          date: "2/12/21",
          desc: "Door 1 has been opened",
        },
        {
          id: 6,
          time: "10:45am",
          date: "2/12/21",
          desc: "Door 1 has been opened",
        },
        {
          id: 7,
          time: "10:45am",
          date: "2/12/21",
          desc: "Door 1 has been opened",
        },
        {
          id: 8,
          time: "10:45am",
          date: "2/12/21",
          desc: "Door 1 has been opened",
        },
        {
          id: 9,
          time: "10:45am",
          date: "2/12/21",
          desc: "Door 1 has been opened",
        },
        {
          id: 10,
          time: "10:45am",
          date: "2/12/21",
          desc: "Door 1 has been opened",
        },
        {
          id: 11,
          time: "10:45am",
          date: "2/12/21",
          desc: "Door 1 has been opened",
        },
        {
          id: 12,
          time: "10:45am",
          date: "2/12/21",
          desc: "Door 1 has been opened",
        },
        {
          id: 13,
          time: "10:45am",
          date: "2/12/21",
          desc: "Door 1 has been opened",
        },
        {
          id: 14,
          time: "10:45am",
          date: "2/12/21",
          desc: "Door 1 has been opened",
        },
      ],
      lineChart1: {
        chartData: {
          labels: [
            "6.00am",
            "7.00am",
            "8.00am",
            "9.00am",
            "10.00am",
            "11.00am",
            "12.00am",
            "1.00pm",
            "2.00pm",
            "3.00pm",
            "4.00pm",
            "5.00pm",
          ],
          datasets: [
            {
              label: "V1",
              fill: true,
              borderColor: "#fe0138",
              borderWidth: 5,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#fe0138",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 0,
              data: [
                8, 10, 7, 8, 12, 8, 8, 10, 7, 8, 12, 8, 8, 10, 7, 8, 12, 8,
              ],
            },
            {
              label: "V2",
              fill: true,
              borderColor: "#fece00",
              borderWidth: 5,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#fece00",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#fece00",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 0,
              data: [
                80, 100, 70, 80, 120, 80, 80, 100, 70, 80, 120, 80, 80, 100, 70,
                80, 120, 80,
              ],
            },
            {
              label: "V3",
              fill: true,
              borderColor: "#0627ff",
              borderWidth: 5,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#0627ff",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#0627ffd",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 0,
              data: [
                40, 40, 40, 50, 50, 30, 30, 30, 40, 60, 60, 60, 60, 60, 40,
              ],
            },
          ],
        },
        extraOptions: chartConfigs.lineChartSmoothLine,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [0, 0, 0],
      },
      lineChart2: {
        chartData: {
          labels: [
            "6.00am",
            "7.00am",
            "8.00am",
            "9.00am",
            "10.00am",
            "11.00am",
            "12.00am",
            "1.00pm",
            "2.00pm",
            "3.00pm",
            "4.00pm",
            "5.00pm",
          ],
          datasets: [
            {
              label: "L1",
              fill: true,
              borderColor: "#fe0138",
              borderWidth: 5,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#fe0138",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 0,
              data: [
                8, 10, 7, 8, 12, 8, 8, 10, 7, 8, 12, 8, 8, 10, 7, 8, 12, 8,
              ],
            },
            {
              label: "L2",
              fill: true,
              borderColor: "#fece00",
              borderWidth: 5,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#fece00",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#fece00",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 0,
              data: [
                80, 100, 70, 80, 120, 80, 80, 100, 70, 80, 120, 80, 80, 100, 70,
                80, 120, 80,
              ],
            },
            {
              label: "L3",
              fill: true,
              borderColor: "#0627ff",
              borderWidth: 5,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#0627ff",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#0627ffd",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 0,
              data: [
                40, 40, 40, 50, 50, 30, 30, 30, 40, 60, 60, 60, 60, 60, 40,
              ],
            },
          ],
        },
        extraOptions: chartConfigs.lineChartSmoothLine,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [0, 0, 0],
      },
      lineChart3: {
        chartData: {
          labels: [
            "6.00am",
            "7.00am",
            "8.00am",
            "9.00am",
            "10.00am",
            "11.00am",
            "12.00am",
            "1.00pm",
            "2.00pm",
            "3.00pm",
            "4.00pm",
            "5.00pm",
          ],
          datasets: [
            {
              label: "L1",
              fill: true,
              borderColor: "#fe0138",
              borderWidth: 5,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#fe0138",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 0,
              data: [
                8, 10, 7, 8, 12, 8, 8, 10, 7, 8, 12, 8, 8, 10, 7, 8, 12, 8,
              ],
            },
            {
              label: "L2",
              fill: true,
              borderColor: "#fece00",
              borderWidth: 5,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#fece00",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#fece00",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 0,
              data: [
                80, 100, 70, 80, 120, 80, 80, 100, 70, 80, 120, 80, 80, 100, 70,
                80, 120, 80,
              ],
            },
            {
              label: "L3",
              fill: true,
              borderColor: "#0627ff",
              borderWidth: 5,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#0627ff",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#0627ffd",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 0,
              data: [
                40, 40, 40, 50, 50, 30, 30, 30, 40, 60, 60, 60, 60, 60, 40,
              ],
            },
          ],
        },
        extraOptions: chartConfigs.lineChartSmoothLine,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [0, 0, 0],
      },
      lineChart4: {
        chartData: {
          labels: [
            "6.00am",
            "7.00am",
            "8.00am",
            "9.00am",
            "10.00am",
            "11.00am",
            "12.00am",
            "1.00pm",
            "2.00pm",
            "3.00pm",
            "4.00pm",
            "5.00pm",
          ],
          datasets: [
            {
              label: "L1",
              fill: true,
              borderColor: "#fe0138",
              borderWidth: 5,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#fe0138",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 0,
              data: [
                8, 10, 7, 8, 12, 8, 8, 10, 7, 8, 12, 8, 8, 10, 7, 8, 12, 8,
              ],
            },
            {
              label: "L2",
              fill: true,
              borderColor: "#fece00",
              borderWidth: 5,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#fece00",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#fece00",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 0,
              data: [
                80, 100, 70, 80, 120, 80, 80, 100, 70, 80, 120, 80, 80, 100, 70,
                80, 120, 80,
              ],
            },
            {
              label: "L3",
              fill: true,
              borderColor: "#0627ff",
              borderWidth: 5,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#0627ff",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#0627ffd",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 0,
              data: [
                40, 40, 40, 50, 50, 30, 30, 30, 40, 60, 60, 60, 60, 60, 40,
              ],
            },
          ],
        },
        extraOptions: chartConfigs.lineChartSmoothLine,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [0, 0, 0],
      },
      lineChart5: {
        chartData: {
          labels: [
            "6.00am",
            "7.00am",
            "8.00am",
            "9.00am",
            "10.00am",
            "11.00am",
            "12.00am",
            "1.00pm",
            "2.00pm",
            "3.00pm",
            "4.00pm",
            "5.00pm",
          ],
          datasets: [
            {
              label: "L1",
              fill: true,
              borderColor: "#fe0138",
              borderWidth: 5,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#fe0138",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 0,
              data: [
                8, 10, 7, 8, 12, 8, 8, 10, 7, 8, 12, 8, 8, 10, 7, 8, 12, 8,
              ],
            },
            {
              label: "L2",
              fill: true,
              borderColor: "#fece00",
              borderWidth: 5,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#fece00",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#fece00",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 0,
              data: [
                80, 100, 70, 80, 120, 80, 80, 100, 70, 80, 120, 80, 80, 100, 70,
                80, 120, 80,
              ],
            },
            {
              label: "L3",
              fill: true,
              borderColor: "#0627ff",
              borderWidth: 5,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#0627ff",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#0627ffd",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 0,
              data: [
                40, 40, 40, 50, 50, 30, 30, 30, 40, 60, 60, 60, 60, 60, 40,
              ],
            },
          ],
        },
        extraOptions: chartConfigs.lineChartSmoothLine,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [0, 0, 0],
      },
      lineChart6: {
        chartData: {
          labels: [
            "6.00am",
            "7.00am",
            "8.00am",
            "9.00am",
            "10.00am",
            "11.00am",
            "12.00am",
            "1.00pm",
            "2.00pm",
            "3.00pm",
            "4.00pm",
            "5.00pm",
          ],
          datasets: [
            {
              label: "L1",
              fill: true,
              borderColor: "#fe0138",
              borderWidth: 5,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#fe0138",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 0,
              data: [
                8, 10, 7, 8, 12, 8, 8, 10, 7, 8, 12, 8, 8, 10, 7, 8, 12, 8,
              ],
            },
            {
              label: "L2",
              fill: true,
              borderColor: "#fece00",
              borderWidth: 5,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#fece00",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#fece00",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 0,
              data: [
                80, 100, 70, 80, 120, 80, 80, 100, 70, 80, 120, 80, 80, 100, 70,
                80, 120, 80,
              ],
            },
            {
              label: "L3",
              fill: true,
              borderColor: "#0627ff",
              borderWidth: 5,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#0627ff",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#0627ffd",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 0,
              data: [
                40, 40, 40, 50, 50, 30, 30, 30, 40, 60, 60, 60, 60, 60, 40,
              ],
            },
          ],
        },
        extraOptions: chartConfigs.lineChartSmoothLine,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [0, 0, 0],
      },
      lineChart7: {
        chartData: {
          labels: [
            "6.00am",
            "7.00am",
            "8.00am",
            "9.00am",
            "10.00am",
            "11.00am",
            "12.00am",
            "1.00pm",
            "2.00pm",
            "3.00pm",
            "4.00pm",
            "5.00pm",
          ],
          datasets: [
            {
              label: "L1",
              fill: true,
              borderColor: "#fe0138",
              borderWidth: 5,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#fe0138",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 0,
              data: [
                8, 10, 7, 8, 12, 8, 8, 10, 7, 8, 12, 8, 8, 10, 7, 8, 12, 8,
              ],
            },
            {
              label: "L2",
              fill: true,
              borderColor: "#fece00",
              borderWidth: 5,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#fece00",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#fece00",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 0,
              data: [
                80, 100, 70, 80, 120, 80, 80, 100, 70, 80, 120, 80, 80, 100, 70,
                80, 120, 80,
              ],
            },
            {
              label: "L3",
              fill: true,
              borderColor: "#0627ff",
              borderWidth: 5,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#0627ff",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#0627ffd",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 0,
              data: [
                40, 40, 40, 50, 50, 30, 30, 30, 40, 60, 60, 60, 60, 60, 40,
              ],
            },
          ],
        },
        extraOptions: chartConfigs.lineChartSmoothLine,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [0, 0, 0],
      },
      lineChart8: {
        chartData: {
          labels: [
            "6.00am",
            "7.00am",
            "8.00am",
            "9.00am",
            "10.00am",
            "11.00am",
            "12.00am",
            "1.00pm",
            "2.00pm",
            "3.00pm",
            "4.00pm",
            "5.00pm",
          ],
          datasets: [
            {
              label: "L1",
              fill: true,
              borderColor: "#fe0138",
              borderWidth: 5,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#fe0138",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 0,
              data: [
                8, 10, 7, 8, 12, 8, 8, 10, 7, 8, 12, 8, 8, 10, 7, 8, 12, 8,
              ],
            },
            {
              label: "L2",
              fill: true,
              borderColor: "#fece00",
              borderWidth: 5,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#fece00",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#fece00",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 0,
              data: [
                80, 100, 70, 80, 120, 80, 80, 100, 70, 80, 120, 80, 80, 100, 70,
                80, 120, 80,
              ],
            },
            {
              label: "L3",
              fill: true,
              borderColor: "#0627ff",
              borderWidth: 5,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#0627ff",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#0627ffd",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 0,
              data: [
                40, 40, 40, 50, 50, 30, 30, 30, 40, 60, 60, 60, 60, 60, 40,
              ],
            },
          ],
        },
        extraOptions: chartConfigs.lineChartSmoothLine,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [0, 0, 0],
      },
      lineChart9: {
        chartData: {
          labels: [
            "6.00am",
            "7.00am",
            "8.00am",
            "9.00am",
            "10.00am",
            "11.00am",
            "12.00am",
            "1.00pm",
            "2.00pm",
            "3.00pm",
            "4.00pm",
            "5.00pm",
          ],
          datasets: [
            {
              label: "L1",
              fill: true,
              borderColor: "#fe0138",
              borderWidth: 5,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#fe0138",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 0,
              data: [
                8, 10, 7, 8, 12, 8, 8, 10, 7, 8, 12, 8, 8, 10, 7, 8, 12, 8,
              ],
            },
            {
              label: "L2",
              fill: true,
              borderColor: "#fece00",
              borderWidth: 5,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#fece00",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#fece00",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 0,
              data: [
                80, 100, 70, 80, 120, 80, 80, 100, 70, 80, 120, 80, 80, 100, 70,
                80, 120, 80,
              ],
            },
            {
              label: "L3",
              fill: true,
              borderColor: "#0627ff",
              borderWidth: 5,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#0627ff",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#0627ffd",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 0,
              data: [
                40, 40, 40, 50, 50, 30, 30, 30, 40, 60, 60, 60, 60, 60, 40,
              ],
            },
          ],
        },
        extraOptions: chartConfigs.lineChartSmoothLine,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [0, 0, 0],
      },
    };
  },
  created() {
    this.getFpList();
    let date = "";
    let time = "";

    // setInterval(() => {
    //   date = moment().format("DD MMMM Y");
    //   time = moment().format("hh:mma");
    //   this.lastupdateddata = date + "   |   " + time;
    this.lastupdatedata = "Unknown";
    // }, 1000);
  },
  beforeDestroy() {
    // console.log("SOCKS_CLOSED");
    this.socket.close();
    // // console.log(this.socket);
  },
  methods: {
    getFpList() {
      this.tableData = [];
      this.$http
        .get(":8002/api/v1/manage/feeder")
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            for (var i = 0; i < response.length; i++) {
              let obj = {
                label: response[i].fp_name,
                value: response[i].fp_id,
                code: response[i].fp_code,
                latitude: response[i].lat,
                longitude: response[i].lon,
              };
              this.fpList.push(obj);
            }

            if (response.length > 0) {
              this.fpid = response[0].fp_id;
              this.fpinfo.fptoken = response[0].fp_token;
              this.getFpInfo();
            }
          } else {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getFpInfo() {
      //Get Fp Info based on ID

      this.$http.get(":8002/api/v1/manage/feeder/" + this.fpid).then((res) => {
        console.log("FP INFO: ", res);

        res.message.info.map((data) => {
          if (data.conntype != "NONE") {
            // this.socket.close()
            let data = res.message
            this.fpinfo.fptoken = data.info[0].fp_token
            this.connType = data.info[0].conntype;
            this.getFpTariff(res.message.attribute);
            this.getFpData();
            this.renderMap(res.message);
            this.getAlertInfo();
            this.getSocketData();
            this.FpControl("ONOFF", "RT");
            console.log("TARIFF: ", this.fpinfo.tariff);
          }
        });
      });
    },
    renderMap(info) {
      let LightList = info.device_assoc;
      let fpInfo = info.info;
      let mapinfo = [];
      //Construct map for Light list
      this.devBounds = [];
      if (LightList.length > 0) {
        LightList.map((a) => {
          let info = {
            flag: a.lighttypeid == 0 ? "hpsvson" : "smart",
            location: L.latLng(a.lat, a.lon),
          };
          this.devBounds.push([a.lat, a.lon]);
          mapinfo.push(info);
        });
      }

      if (fpInfo.length > 0) {
        fpInfo.map((a) => {
          let info = {
            flag: "fp",
            location: L.latLng(a.lat, a.lon),
          };
          this.devBounds.push([a.lat, a.lon]);
          mapinfo.push(info);
        });
      }

      console.log("MAP: ", mapinfo);

      this.markers = mapinfo;
    },
    initLine1(param, data) {
      let avr = 0;
      let devData = null;
      let date = null;
      let timeStamp = [];
      let dataValue1 = [];
      let dataValue2 = [];
      let dataValue3 = [];
      let fullData = [];
      let label = "";

      for (let i = 0; i < data.length; i++) {
        date = data[i].TodayHourly;

        if (param == "voltage") {
          label = "V";

          timeStamp.push(moment(date).format("h:mm a")); //toLocaleTimeString javascript method //x-axis
          dataValue1.push(data[i].Voltage1); //y-axis
          dataValue2.push(data[i].Voltage2); //y-axis
          dataValue3.push(data[i].Voltage3); //y-axis
        } else if (param == "current") {
          label = "L";
          timeStamp.push(moment(date).format("h:mm a")); //toLocaleTimeString javascript method //x-axis

          dataValue1.push(data[i].Amp1 / 100); //y-axis
          dataValue2.push(data[i].Amp2 / 100); //y-axis
          dataValue3.push(data[i].Amp3 / 100); //y-axis
        } else if (param == "energy") {
          label = "L";
          timeStamp.push(moment(date).format("h:mm a")); //toLocaleTimeString javascript method //x-axis
          dataValue1.push(data[i].Energy1 / 1000); //y-axis
          dataValue2.push(data[i].Energy2 / 1000); //y-axis
          dataValue3.push(data[i].Energy3 / 1000); //y-axis
        }

        fullData.push(dataValue1, dataValue2, dataValue3);
      }

      // let nextHour = moment(timeStamp[timeStamp.length - 1], "h:mm a").format(
      //   "h:mm a"
      // );
      // let balanceHour = 24 - timeStamp.length;

      // for (let i = 0; i < balanceHour; i++) {
      //   timeStamp.push(nextHour);
      //   nextHour = moment(nextHour, "h:mm a").add(1, "hours").format("h:mm a");
      // }

      let fullGraphData = [];
      let phaseColor = ["#fe0138", "#fece00", "#0627ff"];
      for (let i = 0; i < 3; i++) {
        let dataset = {
          label: label + (i + 1),
          fill: true,
          borderColor: phaseColor[i],
          borderWidth: 5,
          borderDash: [],
          borderDashOffset: 0.0,
          pointBackgroundColor: config.colors.primary,
          pointBorderColor: "rgba(255,255,255,0)",
          pointHoverBackgroundColor: phaseColor[i],
          pointBorderWidth: 20,
          pointHoverRadius: 4,
          pointHoverBorderWidth: 15,
          pointRadius: 0,
          data: fullData[i],
        };

        let chart = {
          chartData: {
            labels: timeStamp,
            datasets: [dataset],
          },
          extraOptions: chartConfigs.energyChartOptions,
          gradientColors: config.colors.primaryGradient,
          gradientStops: [1, 0.4, 0],
          loaded: true,
        };

        fullGraphData.push(chart);
      }

      console.log();

      if (param == "voltage") {
        console.log("PREPARE : ", fullGraphData[0]);
        this.lineChart1 = fullGraphData[0];
        this.lineChart2 = fullGraphData[1];
        this.lineChart3 = fullGraphData[2];
        console.log("test: ", this.lineChart2);
      } else if (param == "current") {
        this.lineChart4 = fullGraphData[0];
        this.lineChart5 = fullGraphData[1];
        this.lineChart6 = fullGraphData[2];
      } else if (param == "energy") {
        this.lineChart7 = fullGraphData[0];
        this.lineChart8 = fullGraphData[1];
        this.lineChart9 = fullGraphData[2];
      }
    },
    getFpData() {
      this.lineChart1.loaded = false;
      this.lineChart2.loaded = false;
      this.lineChart3.loaded = false;
      let start = moment().startOf("day").utc().unix();
      let end = moment().endOf('day').utc().unix();

      // console.log(today);
      console.log("later " + start);

      this.$http
        .get(
          ":8001/api/v1/insight/device/feeder/" +
            this.fpinfo.fptoken +
            "/" +
            start +
            "/" +
            end
        )
        .then((res) => {
          console.log("DATA:", res);
          if (res.message.length <= 0) {
            // this.resetChart("voltage");
            // this.resetChart("current");
            // this.resetChart("energy");
          } else {
            //get cached data
            // this.cacheTime =
            //   res.message.voltage[res.message.voltage.length - 1].timestamp;
            this.initLine1("voltage", res.message);
            this.initLine1("current", res.message);
            this.initLine1("energy", res.message);
          }
        });
    },
    getSocketData() {
      let url = process.env.VUE_APP_WS_URL;
      if (this.socket != "") {
        this.socket.close();
      }
      this.socket = new WebSocket(
        url + ":8001/api/v1/insight/device/feeder/" + this.fpinfo.fptoken + "/ws"
      );
      this.socket.onopen = () => {
        this.status = "connected";

        this.socket.onmessage = ({ data }) => {
          // console.log("SOCKET: ", data);

          let parsedData = JSON.parse(data);
          let socketdata = parsedData.message.data;
          let dataTS = parsedData.message.timestamp;
          let lastHourTS = parsedData.message.lastdata_ts;

          if (!parsedData.error) {


            this.getAlertInfo()
            //Update state
            this.lastupdateddata = moment();
            // console.log("STATE: ", socketdata.Status);
            if (socketdata.OverrideState == 1) {
              this.modals.alert = true;
              this.fpLastData.controlmode = "Override Mode";
              this.fpcontrol = false;
              console.log("LAST STATE: ", this.modals.laststate);
              if (!this.modals.laststate) {
                this.modals.alert = true;
              } else {
                this.modals.alert = false;
              }
            } else {
              this.fpLastData.controlmode = "Smart Mode";
              this.fpcontrol = true;
              this.modals.alert = false;
              this.modals.laststate = false;
            }

            socketdata.Status == 1
              ? (this.fpLastData.mlcstatus = "ON")
              : (this.fpLastData.mlcstatus = "OFF");

            //Voltage card
            this.fpLastData.voltagel1 = socketdata.Voltage1;
            this.fpLastData.voltagel2 = socketdata.Voltage2;
            this.fpLastData.voltagel3 = socketdata.Voltage3;

            //Current card
            this.fpLastData.currentl1 = socketdata.Amp1 / 100;
            this.fpLastData.currentl2 = socketdata.Amp2 / 100;
            this.fpLastData.currentl3 = socketdata.Amp3 / 100;
            this.fpLastData.totalcurrent =
              (socketdata.Amp1 + socketdata.Amp2 + socketdata.Amp3) / 100;

            //Energy card
            this.fpLastData.energyl1 = socketdata.Energy1 / 1000;
            this.fpLastData.energyl2 = socketdata.Energy2 / 1000;
            this.fpLastData.energyl3 = socketdata.Energy3 / 1000;
            this.fpLastData.ttlenergy =
              (socketdata.Energy1 + socketdata.Energy2 + socketdata.Energy3) /
              1000;

            this.energycosttodate =
              (this.fpLastData.ttlenergy * this.fpinfo.tariff).toFixed(2);

            //Node and GW rssi
            this.fpLastData.node = socketdata.DeviceRssi;
            this.fpLastData.gateway = socketdata.GwRssi;

            //Door 1 and 2 status

            socketdata.DoorStatus1 === 1
              ? (this.fpLastData.Door1Status = "OPEN")
              : (this.fpLastData.Door1Status = "CLOSED");

            socketdata.DoorStatus2 === 1
              ? (this.fpLastData.Door2Status = "OPEN")
              : (this.fpLastData.Door2Status = "CLOSED");
          } else {
            this.energycosttodate = 0.0;
            this.fpLastData = {
              voltagel1: 0,
              voltagel2: 0,
              voltagel3: 0,
              currentl1: 0,
              currentl2: 0,
              currentl3: 0,
              totalcurrent: 0,
              energyl1: 0,
              energyl2: 0,
              energyl3: 0,
              ttlenergy: 0,
              mlcstatus: "Unknown",
              controlmode: "Unknown",
              node: 0,
              gateway: 0,
            };
          }
        };
      };
    },
    FpControl(controlType, value) {
      let actualControl,
        ctx = "";

      if (controlType == "DIMM") {
      } else if (controlType == "ONOFF") {
        actualControl = value;
        ctx = "CONTROL";
      } else if (controlType == "RTC") {
        actualControl = value;
        ctx = "RTC";
      }

      //construct control payload
      console.log("CONN: ", this.connType)
      let controlPayload = {
        conntype: this.connType,
        context: ctx,
        command: [
          {
            data: actualControl,
          },
          {
            data: "RT",
          },
        ],
      };

      //send control to cloud
      var urlAPI = ":8003/api/v1/control/fp/unicast/" + this.fpinfo.fptoken;
      this.$http.post(urlAPI, controlPayload).then((res) => {
        if (!res.error) {
          console.log("CONTROL RESP: ", res.message);
        }
      });
    },
    getAlertInfo() {
      this.$http.get(":8003/api/v1/alert/feeder/" + this.fpinfo.fptoken).then((res) => {
        let data = res.message;

        if (res.message.length > 0) {
          //Get recent door Open
          for (let i = 0; i < res.message.length; i++) {
            if (
              data[i].FaultValue.substring(2, 4) == "A0" ||
              data[i].FaultValue.substring(2, 4) == "B0"
            ) {
              this.fpAlertInfo.lastdooropened = moment(
                data[i].CreatedAt
              ).fromNow();
              break;
            }
          }

          //Render Alert list drawer
          let alertlist = [];
          res.message.map((data, i) => {
            let payload = {
              id: i,
              time: moment(data.CreatedAt).format("h:mm a"),
              date: moment(data.CreatedAt).format("DD/MM/Y"),
              desc: this.constructMessage(data.FaultValue),
            };

            alertlist.push(payload);
          });

          this.alertinfolist = alertlist;
        } else {
          this.fpAlertInfo.lastdooropened = "Unknown";
          this.alertinfolist = [];
        }
      });
    },
    constructMessage(data) {
      switch (data.substring(2, 4)) {
        case "A1":
          return "Feeder pillar door 1 close";
        case "A0":
          return "Feeder pillar door 1 open";
        case "B1":
          return "Feeder pillar door 2 close";
        case "B0":
          return "Feeder pillar door 2 open";
        case "C1":
          return "Switch override ON";
        case "C0":
          return "Switch override OFF";
      }
    },
    getFpTariff(data) {
      data.map((a) => {
        if ((a.key = "FP_ELEC_TARIFF")) {
          this.fpinfo.tariff = a.value;
          return a.value;
        }
      });
    },
  },
};
</script>

<style scoped>
#legend {
  background: #fff;
  margin: 12px;
  color: rgb(86, 86, 86);
  background-color: rgb(255, 255, 255);
  padding: 10px;
  border-radius: 2px;
  background-clip: padding-box;
  box-shadow: 0px 1px 4px -1px rgba(0, 0, 0, 0.3);
}
.legend_attr {
  padding-top: 5px;
}

.drawer {
  position: relative;
  height: 100%;
}

.text-bottom {
  top: 60px;
}

.fonta {
  color: #a8a8a6;
}

.hoi {
  background-color: #ffffff;
  border: 2px solid #bebebe;
  border-radius: 3px;
  color: #1e1e24;
  padding: 3px 12px;
  left: 4px;
  text-align: center;
  font-size: 16px;
}

.hoi:hover {
  background-color: #f4f4f4; /* Green */
  color: #1e1e24;
}
</style>